<template>
  <div>
    <topsearch title="Çağrı Periyodu" />
    <template v-if="loading">
      <div class="root">
        <div class="no-results">
          <vk-spinner v-if="loading" ratio="4"></vk-spinner>
          <h2>Yükleniyor</h2>
          <h6>Yükleniyor lütfen bekleyin</h6>
        </div>
      </div>
    </template>
    <div v-else class="flex content-section">
      <table
        class="uk-table text-sm uk-table-hover heightoverflow uk-table-middle uk-table-divider"
      >
        <thead>
          <tr class="in-table-search">
            <td>
              <button
                type="button"
                @click="filterApply()"
                style="
                  background: none;
                  border: none;
                  margin: 0px;
                  padding: 0px;
                "
              >
                <span class="uk-icon"
                  ><svg
                    version="1.1"
                    meta="vk-icons-search"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                  >
                    <circle
                      fill="none"
                      stroke="#000"
                      stroke-width="1.1"
                      cx="9"
                      cy="9"
                      r="7"
                    ></circle>
                    <path
                      fill="none"
                      stroke="#000"
                      stroke-width="1.1"
                      d="M14,14 L18,18 L14,14 Z"
                    ></path>
                  </svg>
                </span>
              </button>
            </td>
            <td>
              <search-item
                name="search"
                :input="{
                  id: 32,
                  label: 'Temsilci',
                  component: { name: 'selectbox' },
                  display_name: 'Temsilci',
                }"
                :label="false"
                :value="filters.agent_id"
                @changed="(returned) => (filters.agent_id = returned.value)"
                type="selectbox"
              />
            </td>
            <td>
              <search-item
                name="search"
                :input="{
                  id: 16,
                  label: 'Durum',
                  component: { name: 'selectbox' },
                  display_name: 'Durum',
                }"
                :label="false"
                :value="filters.status_id"
                @changed="(returned) => (filters.status_id = returned.value)"
                type="selectbox"
              />
            </td>
            <td colspan="5"></td>
          </tr>
          <tr v-if="selection.length > 0">
            <td></td>
            <td>
              <label>Yeni Müşteri Temsilcisi</label>
            </td>
            <td>
              <search-item
                name="search"
                :input="{
                  id: 32,
                  label: 'Temsilci',
                  component: { name: 'selectbox' },
                  display_name: 'Temsilci',
                }"
                :label="false"
                :value="agent_id"
                @changed="(returned) => (agent_id = returned.value)"
                type="selectbox"
              />
            </td>
            <td @click="bulkUpdate()">
              <savebutton action="addFilters" title="Kaydet" />
            </td>
          </tr>

          <tr>
            <th>
              <input
                type="checkbox"
                class="uk-checkbox"
                @click="selectAll(callPeriodsData)"
              />
            </th>
            <th>İsim soyisim</th>
            <th>Lead Durumu</th>
            <th>Müşteri Temsilcisi</th>
            <th>Aranması Gereken Tarih</th>
            <th>Geçen Gün Sayısı</th>
          </tr>
        </thead>
        <tbody>
          <tr :key="cdata.lead_id" v-for="cdata in callPeriodsData">
            <td>
              <input
                type="checkbox"
                class="uk-checkbox"
                v-model="selection"
                :value="cdata.lead_id"
              />
            </td>
            <td>
              <router-link :to="'/leadDetail/' + cdata.lead_id">{{
                cdata.name
              }}</router-link>
            </td>
            <td>
              <leadStatusVue :rowdata="cdata.status_id" :input="{ id: 16 }" />
            </td>
            <td>
              <selectBoxVueTable
                :rowdata="cdata.agent_id"
                :input="{ id: 32 }"
              />
            </td>
            <td>{{ cdata.datetime }}</td>
            <td>
              <template v-if="cdata.datetime">
                {{ dateDiff(cdata.datetime) }}
              </template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import leadStatusVue from "../components/Ui/Table/leadStatus";

import http from "../services/http";
import selectBoxVueTable from "../components/Ui/Table/selectBox";
import selectBoxVueForm from "../components/Ui/Form/selectBox";
import SearchItemVue from "../components/Ui/SearchItem";
import SaveButtonVue from "../components/Ui/SaveButton";
export default {
  components: {
    "search-item": SearchItemVue,
    leadStatusVue: leadStatusVue,
    selectBoxVueTable: selectBoxVueTable,
    selectBoxVueForm: selectBoxVueForm,
    savebutton: SaveButtonVue,
  },

  data() {
    return {
      select_all: false,
      loading: true,
      bulkForm: [],
      filters: [],
      selection: [],
      agent_id: 0,
      callPeriodsData: [],
    };
  },
  methods: {
    setAgent(val) {},
    selectAll(checkboxs) {
      this.select_all = !this.select_all;
      if (this.select_all == true) {
        checkboxs.forEach((item) => {
          this.selection.push(item.lead_id);
        });
      } else {
        this.selection = [];
      }
    },
    getData() {
      this.callPeriodsData = [];
      http.getCallPeriods(this.filters).then((e) => {
        this.callPeriodsData = e.data.results;
        this.$forceUpdate();
      });
    },
    filterApply() {
      this.getData();
    },

    bulkUpdate() {
      this.$forceUpdate();
      this.bulkForm.ids = this.selection;
      this.bulkForm.table = "leads";
      this.bulkForm.fieldName = "agent_id";
      this.bulkForm.fieldValue = this.agent_id;
      this.loading = true;
      http
        .bulkSave(this.bulkForm)
        .then((e) => {
          setTimeout(() => {
            this.getData();
            this.$forceUpdate();
            this.selection = [];
          }, 100);
        })
        .finally((e) => {
          this.loading = false;
        });
    },
    dateDiff(date) {
      var a = moment(date);
      var b = moment();
      return a.diff(b, "days");
    },
  },
  mounted() {
    http.getCallPeriods().then((e) => {
      this.loading = false;
      this.callPeriodsData = e.data.results;
    });
  },
};
</script>

<style scoped>
a,
.uk-link {
  @apply text-tile-400;
}
</style>
